import { gql } from 'urql';

const GetProfileInfo = gql`
  query GetProfileInfo {
    user {
      id
      customerInfo {
        __typename
        id
        email {
          address
        }
        name {
          first
          last
          full
          initials
        }
        phone
        dateOfBirth
        address {
          addressLine1
          addressLine2
          city
          state
          zip
          country
        }
        mailingAddress {
          addressLine1
          addressLine2
          city
          state
          zip
          country
        }
        canAccessCardService
        profilePhoto {
          hash
          url
        }
        userVoice {
          redirectUrl
        }
        createdAt
        isAddressVerified
        unreadChatMessagesCount
        ssnLastFour
        isMailingAddressDifferentThanResidential
      }
    }
  }
`;

export default GetProfileInfo;
